import React, { useEffect, useState } from 'react';
export function ExitIntentPopup() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('showExitPopup', handler);
    return () => window.removeEventListener('showExitPopup', handler);
  }, []);
  if (!visible) return null;
  const handleAccept = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales + El Altar Digital (Bundle Popup)',
        content_type: 'product',
        value: 18480,
        currency: 'ARS'
      });
    }
    window.location.href = 'https://ebookpromax.com/cart/46614695116958:1';
  };
  const handleDecline = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 14990,
        currency: 'ARS'
      });
    }
    window.location.href = 'https://ebookpromax.com/cart/46586630013086:1';
  };
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Oferta especial antes de finalizar tu compra" data-id="element-79">
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[rgba(10,8,18,0.85)] backdrop-blur-sm" onClick={handleDecline} data-id="element-80" />

      {/* Popup card */}
      <div className="relative w-full max-w-[520px] max-h-[90vh] overflow-y-auto rounded-[20px] border-2 border-[var(--gold)] shadow-[0_0_80px_-10px_rgba(232,150,12,0.3),0_32px_64px_-16px_rgba(0,0,0,0.7)]" style={{
      background: 'linear-gradient(160deg, #1A1628 0%, #221E32 40%, #1A1628 100%)',
      animation: 'popupSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
    }} data-id="element-81">
        {/* Top gold accent line */}
        <div className="h-[3px] bg-[linear-gradient(90deg,transparent,var(--gold),var(--gold-l),var(--flame2),var(--gold),transparent)]" data-id="element-82" />

        {/* HEADER BANNER */}
        <div className="bg-[linear-gradient(135deg,rgba(232,150,12,0.15),rgba(255,107,53,0.08))] border-b border-[rgba(232,150,12,0.2)] px-5 md:px-8 pt-6 pb-5 text-center" data-id="element-83">
          {/* Urgency badge */}
          <span className="inline-flex items-center gap-[6px] py-1.5 px-3 rounded-full border border-[rgba(255,107,53,0.5)] bg-[rgba(255,107,53,0.12)] text-[10px] md:text-[11px] tracking-[0.14em] uppercase text-[var(--flame2)] font-bold mb-3 backdrop-blur-sm" data-id="element-84">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" data-id="element-85">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-86" />
            </svg>
            Oferta exclusiva — Solo en esta pantalla
          </span>

          {/* Title */}
          <h2 className="font-serif text-[clamp(1.6rem,5vw,2.2rem)] font-700 text-white leading-[1.2] mb-2" data-id="element-87">
            🔥 ¡Esperá! No te vayas sin esto...
          </h2>

          {/* Subtitle */}
          <p className="text-[clamp(1rem,2.5vw,1.15rem)] text-[var(--lila-pale)] italic font-400 leading-[1.5]" data-id="element-88">
            ¿Sabías que podés llevar el paquete completo por mucho menos de lo
            que pensás?
          </p>
        </div>

        {/* BODY */}
        <div className="px-5 md:px-8 pt-6 pb-6" data-id="element-89">
          {/* Flashing discount badge */}
          <div className="flex justify-center mb-5" data-id="element-90">
            <a href="https://ebookpromax.com/cart/46614695116958:1" className="inline-flex items-center gap-2 py-2 px-5 rounded-full bg-[linear-gradient(135deg,rgba(232,150,12,0.25),rgba(255,107,53,0.18))] border border-[var(--gold)] text-[clamp(1.1rem,3vw,1.3rem)] font-900 text-[var(--gold-l)] tracking-wide exit-popup-flash no-underline hover:brightness-110 transition-all duration-200" data-id="element-91">
              ⚡ 30% OFF EN EL ALTAR DIGITAL ⚡
            </a>
          </div>

          {/* Main copy */}
          <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-center mb-3" data-id="element-92">
            Llevá el kit completo de sanación emocional y asegurá que cada
            ritual sea una
            <strong className="text-[#E8C88A] font-700" data-id="element-93">
              {' '}
              experiencia de liberación real
            </strong>
            , no un acto superficial.
          </p>

          {/* Supporting copy */}
          <p className="text-[clamp(0.95rem,2.5vw,1.05rem)] text-[var(--muted)] leading-[1.8] font-400 text-center mb-6 italic" data-id="element-94">
            El paquete incluye el ebook principal, los 2 bonos gratis y "El
            Altar Digital" — todo lo que necesitás para cerrar ciclos de verdad.
          </p>

          {/* WHAT'S INCLUDED LIST */}
          <div className="bg-[rgba(232,150,12,0.04)] border border-[rgba(232,150,12,0.15)] rounded-xl p-4 md:p-5 mb-6" data-id="element-95">
            <div className="text-[clamp(0.65rem,1.5vw,0.75rem)] uppercase tracking-[0.15em] text-[var(--gold)] font-700 mb-3 text-center" data-id="element-96">
              Tu paquete completo incluye:
            </div>
            <div className="flex flex-col gap-[10px]" data-id="element-97">
              <div className="flex items-start gap-3 text-[clamp(1rem,2.5vw,1.1rem)] text-[var(--text)] font-400 leading-[1.7]" data-id="element-98">
                <span className="text-[var(--gold)] flex-shrink-0 mt-[2px]" data-id="element-99">
                  📘
                </span>
                <span data-id="element-100">
                  <strong className="text-white font-700" data-id="element-101">
                    33 Rituales para Soltar el Pasado
                  </strong>{' '}
                  — El método completo de liberación emocional
                </span>
              </div>
              <div className="flex items-start gap-3 text-[clamp(1rem,2.5vw,1.1rem)] text-[var(--text)] font-400 leading-[1.7]" data-id="element-102">
                <span className="text-[var(--gold)] flex-shrink-0 mt-[2px]" data-id="element-103">
                  📓
                </span>
                <span data-id="element-104">
                  <strong className="text-white font-700" data-id="element-105">
                    Bono: Diario Terapéutico
                  </strong>{' '}
                  — Ordená tus emociones y profundizá cada ritual
                </span>
              </div>
              <div className="flex items-start gap-3 text-[clamp(1rem,2.5vw,1.1rem)] text-[var(--text)] font-400 leading-[1.7]" data-id="element-106">
                <span className="text-[var(--gold)] flex-shrink-0 mt-[2px]" data-id="element-107">
                  ⚡
                </span>
                <span data-id="element-108">
                  <strong className="text-white font-700" data-id="element-109">
                    Bono: 7 Rituales de Emergencia
                  </strong>{' '}
                  — Para momentos de crisis emocional intensa
                </span>
              </div>
              <div className="flex items-start gap-3 text-[clamp(1rem,2.5vw,1.1rem)] text-[var(--text)] font-400 leading-[1.7] border-t border-[rgba(232,150,12,0.15)] pt-[10px] mt-[4px]" data-id="element-110">
                <span className="text-[var(--gold)] flex-shrink-0 mt-[2px]" data-id="element-111">
                  🕯️
                </span>
                <span data-id="element-112">
                  <strong className="text-[var(--gold-l)] font-700" data-id="element-113">
                    El Altar Digital
                  </strong>{' '}
                  — Que tus rituales funcionen 10x más rápido preparando tu
                  espacio y sistema nervioso
                </span>
              </div>
            </div>
          </div>

          {/* PRICING BLOCK */}
          <div className="text-center mb-6" data-id="element-114">
            {/* Trust badge */}
            <div className="flex items-center justify-center gap-[6px] text-[clamp(0.7rem,1.5vw,0.78rem)] text-[var(--text)] opacity-70 mb-3 font-400" data-id="element-115">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--gold)]" data-id="element-116">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-117" />
              </svg>
              Pago seguro · Descarga inmediata · Garantía 7 días
            </div>

            {/* Strikethrough price */}
            <div className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--muted)] line-through decoration-[rgba(232,150,12,0.4)] mb-1 font-400" data-id="element-118">
              Precio normal: $19.980 ARS
            </div>

            {/* Special offer price */}
            <div className="font-serif text-[clamp(2.8rem,10vw,4rem)] text-[var(--gold-l)] font-900 leading-none mb-1" style={{
            textShadow: '0 0 40px rgba(245,192,48,0.3), 0 0 80px rgba(232,150,12,0.15)'
          }} data-id="element-119">
              $18.480 ARS
            </div>

            {/* Label */}
            <p className="text-[clamp(0.7rem,1.5vw,0.78rem)] tracking-[0.1em] uppercase text-[var(--flame2)] font-700 mt-1" data-id="element-120">
              Precio especial solo disponible en esta pantalla
            </p>
          </div>

          {/* CTA BUTTONS */}
          <div className="flex flex-col items-center gap-3" data-id="element-121">
            {/* Accept button */}
            <button onClick={handleAccept} className="exit-popup-accept-btn w-full max-w-[460px] inline-flex items-center justify-center gap-2 bg-[linear-gradient(135deg,var(--gold)_0%,var(--gold-l)_50%,var(--gold)_100%)] bg-[length:200%_auto] text-[#1A1025] font-bold text-[clamp(0.9rem,3vw,1.05rem)] tracking-[0.05em] uppercase py-[18px] px-6 rounded-full border-none cursor-pointer transition-all duration-300 leading-[1.2] text-center" style={{
            animation: 'exitPopupPulse 2.5s ease-in-out infinite',
            fontFamily: "'Lato', sans-serif"
          }} data-id="element-122">
              🔥 SÍ, QUIERO EL PAQUETE COMPLETO POR $18.480
            </button>

            {/* Decline button */}
            <button onClick={handleDecline} className="bg-transparent border-none cursor-pointer text-[clamp(0.85rem,2vw,0.95rem)] text-[var(--muted)] hover:text-[var(--text)] transition-colors duration-200 py-2 px-4 font-400 italic" style={{
            fontFamily: "'Lato', sans-serif"
          }} data-id="element-123">
              No gracias, continuar sin los extras →
            </button>
          </div>
        </div>

        {/* Close button */}
        <button onClick={handleDecline} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-[var(--muted)] hover:text-white hover:bg-[rgba(255,255,255,0.1)] transition-all duration-200 cursor-pointer" aria-label="Cerrar" data-id="element-124">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-125">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-126" />
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-127" />
          </svg>
        </button>
      </div>
    </div>;
}